export default {
    items: [
        {
            name: 'Dashboard',
            type: 'dashboard',
            route: 'dashboard',
            iconClasses: ['font-icon', 'font-icon-dashboard'],
            iconClass: 'material-icons',
            iconName: 'dashboard',
            color: 'navy',
        },
        {
            name: 'Content',
            children: [
                { name: 'Pages', route: 'pages', type: 'page' },
                { name: 'Panel library', route: 'panels', type: 'panel' },
                { name: 'Notifications', route: 'notifications', type: 'notification' },
            ],
            iconClass: 'material-icons',
            iconName: 'content_copy',
            color: 'navy',
        },
        // {
        //     name: 'News',
        //     route: 'posts',
        //     type: 'post',
        //     iconClass: 'material-icons',
        //     iconName: 'perm_media',
        //     color: 'navy',
        // },
        {
            name: 'Assets',
            route: 'assets',
            type: 'asset',
            iconClass: 'material-icons',
            iconName: 'photo_album',
            color: 'navy',
        },
        {
            name: 'Products',
            children: [
                { name: 'Products', route: 'products', type: 'product' },
                // { name: 'Product Attributes', route: 'product_attributes', type: 'product_attribute', shortcut: 'product_attribute/_' },
                { name: 'Categories', route: 'categories', type: 'category' },
                { name: 'JIWA Categories', route: 'product_groups', type: 'product_group' },
                // { name: 'JIWA Categories', route: 'category_groups', type: 'category_group' },
                { name: 'Brands', route: 'brands', type: 'brand' },
                { name: 'Product Lists', route: 'product_lists', type: 'product_list' },
                { name: 'Discount Codes', route: 'discount_codes', type: 'discount_code' },
            ],
            iconClass: 'material-icons',
            iconName: 'store',
            color: 'navy',
        },
        {
            name: 'Customers',
            children: [
                { name: 'Customers', route: 'customers', type: 'customer' },
                { name: 'B2B Logins', route: 'customer_logins?filter=id(c):$b2b_customer(1);', type: 'customer_login' },
                { name: 'B2C Logins', route: 'customer_logins?filter=id(c):$b2b_customer(0);', type: 'customer_login' },
                { name: 'Search Queries', route: 'customer_queries', type: 'customer_query' },
                { name: 'Logins Report', route: 'report_logins', type: 'report_login' },
            ],
            // type: 'customer',
            // route: 'customers',
            iconClass: 'material-icons',
            iconName: 'perm_contact_calendar',
            color: 'navy',
        },
        // {
        //     name: 'Training Courses',
        //     route: 'courses',
        //     type: 'course',
        //     iconClass: 'material-icons',
        //     iconName: 'school',
        //     color: 'navy',
        // },
        {
            name: 'Enquiries',
            children: [
                { name: 'Enquiries', route: 'enquiries', type: 'enquiry' },
                { name: 'Subscribers', route: 'subscribers?filter=email_verified:1', type: 'subscriber' },
            ],
            iconClass: 'material-icons',
            iconName: 'forum',
            color: 'navy',
        },
        {
            name: 'Orders',
            type: 'order',
            route: 'orders',
            iconClass: 'material-icons',
            iconName: 'assignment',
            color: 'navy',
        },
        {
            name: 'Invoices',
            type: 'invoice',
            route: 'invoices',
            iconClass: 'material-icons',
            iconName: 'assignment',
            color: 'navy',
        },
        {
            name: 'Accounts',
            children: [
                { name: 'Users', route: 'users', type: 'user' },
                { name: 'Roles', route: 'roles', type: 'role' },
            ],
            iconClass: 'material-icons',
            iconName: 'account_box',
            color: 'navy',
        },
        {
            name: 'Settings',
            children: [
                { name: 'Settings', route: 'settings', type: 'setting' },
                { name: 'Redirect URLs', route: 'redirect_urls', type: 'redirect_url' },
            ],
            iconClass: 'material-icons',
            iconName: 'settings',
            color: 'navy',
        },
    ],
    defaultItem: 'Content',
}


// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/menu.js